<template>
    <div class="container-fluid px-0">
        <h1 class="page-title letraDelTitulo col-12">DIRECTORIO DE INMUEBLES</h1>
        <div class="container-medium">
            <div class="row d-flex">
                    <div v-for="informacionDelInmueble in informacionDeLosInmuebles" v-bind:key="informacionDelInmueble.id" class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 acomodaElDirectorio">
                        <div class="tarjetaDelInmueble col-12 col-md-12">
                            <div class="titulo row">
                                <h5 class="text-center">{{informacionDelInmueble.nombre}}</h5>
                                <h6 class="text-center" style="margin: auto; margin-bottom: 1em; white-space: pre-line;">{{informacionDelInmueble.subTitulo}}</h6>
                            </div>
                            <!--<div :id="informacionDelInmueble.id" class="mapa">
                                <DxMap
                                    :zoom="12" 
                                    :height="400"
                                    :controls="true"
                                    :disabled="false"
                                    type.sync="roadmap"
                                    :center="informacionDelInmueble.localizacion"
                                    :markers="[{ location: informacionDelInmueble.localizacion }]"
                                    width="100%"
                                    :provider="enumeraciones_devextreme.google.proveedor"
                                    >
                                    <DxKey :google="enumeraciones_devextreme.google.llave" />
                                </DxMap>
                            </div>-->

                            <div class="contacto col-12 col-md-12 card">
                                <iframe v-if="informacionDelInmueble.linkMaps!=null" :src="informacionDelInmueble.linkMaps" 
                               frameborder="0" style="border:0; height: 500px; width: 440px " class="mapaContacto" allowfullscreen="" aria-hidden="false" tabindex="0">
                                 </iframe>
                            </div>

                            <ul class="list-group">
                                <li class="list-group-item" v-for="instituciones in informacionDelInmueble.contacto.instituciones" :key="instituciones">
                                    <a>
                                        <span class="acomodaMultiplesLineasDeDireccion">
                                            <i class="fa fa-university fa-lg"></i>
                                        </span>
                                        <span>{{instituciones}}</span>
                                    </a> 
                                </li>
                                <li class="list-group-item" v-for="domicilio in informacionDelInmueble.contacto.domicilio" :key="domicilio">
                                    <a>
                                        <span class="acomodaMultiplesLineasDeDireccion">
                                            <i class="fa fa-map-marker fa-lg"></i>
                                        </span>
                                        <span>{{domicilio}}</span>
                                    </a> 
                                </li>
                                <li v-for="telefono in informacionDelInmueble.contacto.telefonos" v-bind:key="telefono" class="list-group-item">
                                    <a>
                                        <span>
                                            <i class="fas fa-phone"></i>
                                        </span>
                                        <span>{{telefono}}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import enumeraciones_devextreme from "@/../static/js/enumeraciones/devextreme.js";
import DxMap, {
    DxKey
} from 'devextreme-vue/map';

export default {
    components: {
        DxMap, 
        DxKey
    },
    data () {
      return {
        enumeraciones_sicpo,
        enumeraciones_devextreme,
        informacionDeLosInmuebles: [
            {
                id: "mapa_1",
                nombre: "H. Supremo Tribunal de Justicia, Consejo de la Judicatura Estatal y Palacio de Justicia Mercantil y Civil", 
                contacto: {
                    domicilio: ["Av. Héroe. de Nacozari esquina Av. López Mateos S/N Col. San Luis C.P. 20250 Aguascalientes, Ags."],
                    telefonos: ["(449) 910-35-50"]
                },
                localizacion: { lat: 21.879191, lng: -102.281960 },
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2077.930298397578!2d-102.28272262711296!3d21.87871179145755!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429ee73bc1d1795%3A0x9e46e612cb854b5a!2sEdificio%20de%20Justicia%20Civil%20del%20Estado%20de%20Aguascalientes!5e0!3m2!1ses-419!2smx!4v1763051211644!5m2!1ses-419!2smx"
            }, 
           /* {
                id: "mapa_2",
                nombre: "Sala Administrativa", 
                contacto: {
                    domicilio: "Juan de Montoro #219 Planta Baja y Planta Alta Zona Centro C.P. 20000 Aguascalientes, Ags.",
                    telefonos: ["(449) 915-92-28", "(449) 916-12-89"]
                },
                localizacion: { lat: 21.881152, lng: -102.292940 }
            }, */
            {
                id: "mapa_3",
                nombre: "Centro de Mediación",
                subTitulo:"Edificio de Justicia Alternativa",
                contacto: {
                    instituciones:["Centro de Mediación"],
                    domicilio: ["Avenida Grey Yungari, Esquina con carretera a Calvillo km 7.5, Colonia San Felipe. C.P 20310"],
                    telefonos: ["(449)993-81-79, (449)993-74-61,(449) 322-09-95 → Centro de Mediación"],
                },
                localizacion: { lat:21.88268261803136, lng: -102.3644208571088 },
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3702.343320409523!2d-102.3669947239857!3d21.88285145789552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429e9415807a34b%3A0x5fd5bbffd7023d22!2sCentro%20de%20Mediaci%C3%B3n%20del%20Poder%20Judicial%20del%20Estado%20de%20Aguascalientes!5e0!3m2!1ses-419!2smx!4v1763053474988!5m2!1ses-419!2smx"
            }, 
            {
                id: "mapa_17",
                nombre: "Universidad Judicial del Estado de Aguascalientes", 
                contacto: {
                    domicilio:[ "Av. Ojocaliente #703 Fracc. Municipio Libre C.P. 20199 Aguascalientes, Ags."],
                    telefonos: ["(449)979-20-95", "(449)979-20-96"]
                },
                localizacion: { lat: 21.898349, lng: -102.258777 },
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3701.9400927357055!2d-102.26125852398545!3d21.89838255734202!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429ee21b95832ab%3A0x530b19d7d0353105!2sAv.%20Ojocaliente%20703%2C%20Municipio%20Libre%2C%2020199%20Aguascalientes%2C%20Ags.!5e0!3m2!1ses-419!2smx!4v1763053586751!5m2!1ses-419!2smx"
            }, 
            {
                id: "mapa_4",
                nombre: "Palacio de Justicia Poniente",
                subTitulo:"Unidad de Transparencia y Unidad de Igualdad de Género y Derechos Humanos \n(Antes Palacio de Justicia Penal)",
                contacto: {
                    instituciones:["Juzgado 1o Familiar","Juzgado 2o Familiar", "Juzgado 3o Familiar","Juzgado 4o Familiar","Juzgado 6o Familiar","Juzgado 2o Penal", "Unidad de Igualdad de Género y Derechos Humanos", "Unidad de Transparencia","Órgano Interno de Control del Poder Judicial","Asuntos Técnicos y Planeación"],
                    domicilio: ["Carretera a Calvillo Km 7.5 Colonia San Felipe C.P. 20310 Aguascalientes, Ags."],
                    telefonos: ["(449) 910-35-50 ext. 2317 → Juzgado 2° Familiar","4499102309 → Unidad de Igualdad de Género y Derechos Humanos","4499102308 → Unidad de Transparencia","449-910-23-05 → Órgano Interno de Control del Poder Judicial", "449-910-23-00 → Asuntos Técnicos y Planeación"]
                },
                localizacion: { lat: 21.882019, lng: -102.366415 },
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3702.3525676905183!2d-102.36804187398573!3d21.882495157908192!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429e9737c2b26eb%3A0x36a0b06cc7302663!2sPalacio%20de%20Justicia%20Poniente!5e0!3m2!1ses-419!2smx!4v1763053673327!5m2!1ses-419!2smx"
            }, 
            /*{
                id: "mapa_5",
                nombre: "Juzgado de Ejecución de Penas y Medidas de Seguridad", 
                contacto: {
                    domicilio: ["Carretera a Calvillo Km 7.5 Colonia San Felipe C.P. 20310 Aguascalientes, Ags."],
                    telefonos: ["(449) 910-35-50 ext. 2315"]
                },
                localizacion: { lat: 21.882019, lng: -102.366415 }
            },*/ 
            {
                id: "mapa_6",
                nombre: "Juzgado de Control, Juicio Oral y de Ejecución especializado en Justicia para Adolescentes", 
                contacto: {
                    domicilio: ["Román Loera S/N casi esquina con Blvd. Alejandro de la Cruz Saucedo Colonia Solidaridad Jesús María, Ags."],
                    telefonos: ["(449) 963-57-61"]
                },
                localizacion: { lat: 21.952831, lng: -102.351911 },
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3702.3525676905183!2d-102.36804187398573!3d21.882495157908192!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429e94159656e97%3A0x6a1fd47c760c4a2d!2sJuzgado%20De%20Control%20y%20Juicio%20Oral%20Penal%20del%20Primer%20Partido%20Judicial%20-%20Poder%20Judicial%20del%20Estado%20de%20Aguascalientes!5e0!3m2!1ses-419!2smx!4v1763053774244!5m2!1ses-419!2smx"
            }, 
           /* {
                id: "mapa_9",
                nombre: "Sala Unitaria Especializada en el Sistema Integral de Justicia para Adolescentes y en Ejecución de Penas y Medidas de Seguridad", 
                contacto: {
                    domicilio:[ "Av. Héroe. de Nacozari esquina Av. López Mateos S/N Col. San Luis C.P. 20250 Aguascalientes, Ags."],
                    telefonos: ["(449) 910-35-50 Ext: 4429"]
                },
                localizacion: { lat: 21.879191, lng: -102.281960}
            },*/ 
            {
                id: "mapa_7",
                nombre: "Juzgado Mixto y Juzgado de Control de Calvillo", 
                contacto: {
                    domicilio: ["Independencia 602-A esquina con Guanajuato Colonia Centro C.P. 20800 Calvillo, Ags."],
                    telefonos: ["(495) 956-08-65"]
                },
                localizacion: { lat: 21.845431, lng: -102.723686 },
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d396.8310760232346!2d-102.72397320734605!3d21.845210378735153!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429cc0585948025%3A0xd1e3ce5d764dc201!2sJuzgados%20de%20Calvillo%20del%20Poder%20Judicial%20del%20Estado%20de%20Aguascalientes!5e0!3m2!1ses-419!2smx!4v1763053965171!5m2!1ses-419!2smx"
            }, 
            {
                id: "mapa_8",
                nombre: "Juzgado Mixto y Juzgado de Control de Pabellón de Arteaga", 
                contacto: {
                    domicilio: ["Lerdo de Tejada esquina Venustiano Carranza Zona Centro C.P. 20670 Pabellón de Arteaga, Ags."],
                    telefonos: ["(465) 958-12-27","(465) 958-81-77"]
                },
                localizacion: { lat: 22.150241, lng: -102.278935 },
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1411.1104913159127!2d-102.27914949207661!3d22.149891844628122!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429e3d9df9180e3%3A0xb50ea342682b2d25!2sJuzgados%20de%20Pabell%C3%B3n%20de%20Arteaga%20del%20Poder%20Judicial%20del%20Estado%20de%20Aguascalientes!5e0!3m2!1ses-419!2smx!4v1763054056161!5m2!1ses-419!2smx"
            }, 
          /*  {
                id: "mapa_9",
                nombre: "Juzgado de Control y de Juicio Oral Penal de Pabellón de Arteaga", 
                contacto: {
                    domicilio: "Lerdo de Tejada esquina Venustiano Carranza Zona Centro C.P. 20670 Pabellón de Arteaga, Ags.",
                    telefonos: ["(465) 958-81-77"]
                },
                localizacion: { lat: 22.150241, lng: -102.278935 }
            }, */
            {
                id: "mapa_10",
                nombre: "Juzgado Mixto y Juzgado de Control de Rincón de Romos", 
                contacto: {
                    domicilio: ["Av. Constitución 1917 #302 Colonia San José C.P. 20408 Rincón de Romos, Ags."],
                    telefonos: ["(465) 851-52-37", "(465) 851-43-53"]
                },
                localizacion: { lat: 22.225223, lng: -102.323423 },
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1846.7007658909831!2d-102.32286091572193!3d22.224839028595415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8682093f5679d347%3A0xcafc66b3b53a479e!2sJuzgado%20De%20Control%20Y%20Juicio%20Oral!5e0!3m2!1ses-419!2smx!4v1763055637087!5m2!1ses-419!2smx"
            }, 
            {
                id: "mapa_11",
                nombre: "Juzgado 5° Familiar - Especializado", 
                contacto: {
                    domicilio: ["Av. Aguascalientes Oriente #3114 Fracc. El Cedazo C.P. 20295 Aguascalientes, Ags."],
                    telefonos: ["(449) 239-93-96","(449) 239-25-23"]
                },
                localizacion: { lat: 21.866883229550787, lng: -102.2528000104494 },
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d962.0342864343432!2d-102.25343030184621!3d21.8664445134549!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429f2073a90ffbd%3A0x1c61ac6388d2ee87!2sCentro%20de%20Justicia%20para%20las%20Mujeres%20-%20Fiscal%C3%ADa%20General%20del%20Estado%20de%20Aguascalientes!5e0!3m2!1ses-419!2smx!4v1763055550242!5m2!1ses-419!2smx"
            }, 
            {
                id: "mapa_12",
                nombre: "Juzgado Mixto y Juzgado de Control de Jesús María", 
                contacto: {
                    domicilio: ["Mina esquina Saucedo Fracc. Martínez Andrade C.P. 20900 Jesús María, Ags."],
                    telefonos: ["(449) 963-60-20", "(449) 963-98-59"]
                },
                localizacion: { lat: 21.958429, lng: -102.345338 },
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3700.3806438987076!2d-102.34785132398432!3d21.958349455201656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429ef553c64dc6f%3A0x1eef0e79615d0502!2sSaucedo%20%26%20Francisco%20Javier%20Mina%2C%20Mart%C3%ADnez%20Andrade%2C%2020926%20Jes%C3%BAs%20Mar%C3%ADa%2C%20Ags.!5e0!3m2!1ses-419!2smx!4v1763055427521!5m2!1ses-419!2smx"
            }, 
            {
                id: "mapa_13",
                nombre: "Archivo Judicial", 
                contacto: {
                    domicilio: ["Calle Guadalupe 612 Barrio de Guadalupe C.P. 20050 Aguascalientes, Ags."],
                    telefonos: ["(449) 916-51-78", "(449) 916-52-96", "(449) 910-35-69 ext: 3569"]
                },
                localizacion: { lat: 21.885178487575285, lng: -102.30826535825715},
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3702.2903281072704!2d-102.3108705239856!3d21.8848931578228!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429ee8eefaeb593%3A0x82e53100531dfae6!2sC.%20Guadalupe%20612%2C%20Barrio%20de%20Guadalupe%2C%2020059%20Aguascalientes%2C%20Ags.!5e0!3m2!1ses-419!2smx!4v1763054831689!5m2!1ses-419!2smx"
            },
            {
                id: "mapa_14",
                nombre: "Oralidad Aguascalientes", 
                subTitulo:"Juzgado 2° Penal",
                contacto: {
                    domicilio:[ "Avenida Grey Yungari, Esquina con carretera a Calvillo km 7.5, Colonia San Felipe. C.P 20310"],
                    telefonos: ["(449) 977-93-04"]
                },
                localizacion: { lat:21.88268261803136, lng: -102.3644208571088},
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3702.340010193078!2d-102.364856!3d21.882979!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429e94159656e97%3A0x6a1fd47c760c4a2d!2sJuzgado%20De%20Control%20y%20Juicio%20Oral%20Penal%20del%20Primer%20Partido%20Judicial%20-%20Poder%20Judicial%20del%20Estado%20de%20Aguascalientes!5e0!3m2!1ses-419!2smx!4v1763054908735!5m2!1ses-419!2smx"
            },
            {
                id: "mapa_15",
                nombre: "Tribunal Laboral", 
                contacto: {
                    domicilio: ["Av. Héroe. de Nacozari esquina Av. López Mateos S/N Col. San Luis C.P. 20250 Aguascalientes, Ags."],
                    telefonos: ["(449) 322-18-92"]
                },
                localizacion: { lat: 21.879191, lng: -102.281960 },
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1166.1959196782177!2d-102.2825630000911!3d21.879087389196158!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429ee73bc1d1795%3A0x9e46e612cb854b5a!2sEdificio%20de%20Justicia%20Civil%20del%20Estado%20de%20Aguascalientes!5e0!3m2!1ses-419!2smx!4v1763055001791!5m2!1ses-419!2smx"
            },
            {
                id: "mapa_16",
                nombre: "Juzgado de Ejecución de Penas y Medidas de Seguridad",
                contacto: {
                    domicilio: ["Avenida Grey Yungari, Esquina con carretera a Calvillo km 7.5, Colonia San Felipe. C.P 20310"],
                    telefonos: ["449-963-57-61","449-963-97-85"]
                },
                localizacion: { lat: 21.952831, lng: -102.351911} ,
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3702.347252403078!2d-102.36689732398575!3d21.88269995790101!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429e9415807a34b%3A0x5fd5bbffd7023d22!2sCentro%20de%20Mediaci%C3%B3n%20del%20Poder%20Judicial%20del%20Estado%20de%20Aguascalientes!5e0!3m2!1ses-419!2smx!4v1763055097079!5m2!1ses-419!2smx"
            },
            /*{
                id: "mapa_18",
                nombre: "Organos Auxiliares",
                subTitulo:"",
                contacto: {
                    instituciones:["Contraloria Interna","Secretaría Técnica"],
                    domicilio:["Juan de Montoro No. 219, Zona Centro. C.P.20000"],
                    telefonos: ["(449) 916-12-89","(449) 153-79-65","(449) 916-10-53","(449) 915-92-28"]
                },
                localizacion: { lat:21.881206855212184, lng: -102.29294344926998},
                linkMaps:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3702.385811460042!2d-102.2929787773644!3d21.88121422181128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429ee7b3c74e6fb%3A0x1a03128da067b955!2sC.%20Juan%20de%20Montoro%20219%2C%20Zona%20Centro%2C%2020000%20Aguascalientes%2C%20Ags.!5e0!3m2!1ses-419!2smx!4v1763055164908!5m2!1ses-419!2smx"
                
            }*/


        ],
        nombreDeVariableDelComponente: "cargoPaginaOficial",
      }
    },
    mounted() {
      this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
    }
}
</script>

<style scoped>
    h5 {
        width: 100%;
        min-height: 48px;
        margin-bottom: 0;
    }

    ul {
        padding-top: 25px;
        padding-bottom: 15px;
    }

    ul li {
        list-style: none;
    }

    ul li a {
        display: block;
    }

    ul li a span {
        position: relative;
        display: inline-block;
        height: 100%;
    }

    ul li a span:nth-child(1) {
        width: 6%;
    }

    .acomodaMultiplesLineasDeDireccion {
        top: -15px;
        display: contents;
    }

    ul li a span:nth-child(2) {
        width: 93%;
    }

    .page-title {
        background-color: rgb(0,117,115);
        color: #FFF;
        padding: 2vh 20vw;
    }

    .container-medium {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto;
    }

    @media (min-width: 1200px) {
        .container-medium {
            max-width: 1600px;
        }
    }

    .acomodaElDirectorio {
        display: inline-flex;
        padding: 20px;
    }

    .tarjetaDelInmueble {
        display: block;
        border: 1px solid rgb(219, 219, 219);
        background-color: rgba(0,0,0,.03) !important;
        min-height: 620px;
    }

    .titulo {
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
        min-height: 68px !important;
        background-color: rgb(0,117,115) !important;
        color: white;
        vertical-align: middle;
    }

    .mapa {
        padding-top: 15px;
        height: 400px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/Funciones/DirectorioDeInmuebles/DirectorioDeInmuebles.vue